import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['toggle', 'state', 'field', 'controls', 'content'];

    connect() {
        this._handleFormReset = this._handleFormReset.bind(this);
        this.form = this.element.closest('form');
        this.form?.addEventListener('reset', this._handleFormReset);
        this.update();
    }

    disconnect() {
        this.form?.removeEventListener('reset', this._handleFormReset);
    }

    toggle() {
        this.update(true);
    }

    stateChanged() {
        this.toggleTarget.checked = this.stateTarget.value === 'true';
        this.update();
    }

    update(refreshSlider = false) {
        const enabled = this.toggleTarget.checked;
        this.stateTarget.value = String(enabled);
        this.fieldTargets.forEach((field) => {
            field.disabled = !enabled;
        });
        this.controlsTargets.forEach((controls) => {
            controls.classList.toggle('opacity-45', !enabled);
            controls.setAttribute('aria-disabled', String(!enabled));
        });

        if (enabled && refreshSlider && this.hasContentTarget) {
            this.contentTarget.dispatchEvent(new CustomEvent('range-pair:sync'));
        }
    }

    _handleFormReset() {
        requestAnimationFrame(() => {
            this.toggleTarget.checked = false;
            this.update();
        });
    }
}
